import React from 'react';
import { withRouter } from 'react-router-dom';
import { PrimaryTableRowText, TableColumnTitle } from '../../../../shared/globalStyling/styledText';
import { Card, Input, Row, Select, Spin, Table } from 'antd';

const { Search } = Input;

const TopPageViewTable = ({
  loading = false,
  title = 'Top 10 Pages',
  topData = [],
  setSelectedTop,
  selectedTop = 'top10',
  history,
  location,
}) => {
  const url = new URLSearchParams(location.search).get('url') || '';
  const columns = [
    {
      title: '',
      dataIndex: 'color',
      key: 'color',
      width: '30px',
      render: (text) => {
        return (
          <Row
            type="flex"
            justify="center"
            align="middle"
            style={{
              width: '100%',
            }}
          >
            <div
              style={{
                backgroundColor: text,
                height: '15px',
                width: '15px',
                minWidth: '15px',
                borderRadius: '50px',
              }}
            />
          </Row>
        );
      },
    },
    {
      title: <TableColumnTitle text={'Page'} />,
      index: 'value',
      key: 'value',
      width: '60%',
      render: (text, { value }) => {
        return <PrimaryTableRowText text={value} />;
      },
    },
    {
      title: <TableColumnTitle text={'Transactions'} />,
      index: 'counts',
      key: 'counts',
      render: (text, { counts }) => {
        return <PrimaryTableRowText text={counts} />;
      },
    },
    {
      title: <TableColumnTitle text={'Actions'} />,
      key: 'actions',
      render: (text, record) => {
        return (
          <a href={record.value} target="_blank" rel="noopener noreferrer">
            Visit Page
          </a>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <Card
        title={title}
        extra={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <Search
              key={url}
              placeholder="Search URL or slug"
              defaultValue={url}
              allowClear
              onSearch={(value) => {
                const nextPage = location.pathname.split('/');
                nextPage[4] = 1;
                const searchParams = new URLSearchParams(location.search);
                searchParams.delete('url');
                if (value !== '' && value !== null) {
                  searchParams.append('url', value);
                }
                history.push({
                  pathname: nextPage.join('/'),
                  search: `?${searchParams.toString()}`,
                });
              }}
              style={{ width: 240 }}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>Show Top</span>
              <Select
                style={{ width: '80px' }}
                defaultValue={'top5'}
                options={[
                  { label: '5', value: 'top5' },
                  { label: '10', value: 'top10' },
                  { label: '20', value: 'top20' },
                  { label: 'All Time', value: 'all' },
                ]}
                onChange={(value) => {
                  setSelectedTop(value);
                }}
              />
            </div>
          </div>
        }
      >
        <Spin spinning={loading}>
          <Table
            scroll={{ x: 800, y: 400 }}
            dataSource={topData}
            rowKey={(record) => record.value}
            pagination={
              selectedTop !== 'top10' && selectedTop !== 'top5'
                ? {
                    position: ['none', 'bottomCenter'],
                    total: topData.length,
                    responsive: true,
                    showSizeChanger: false,
                    showLessItems: true,
                    size: 'default',
                  }
                : false
            }
            columns={columns}
          />
        </Spin>
      </Card>
    </React.Fragment>
  );
};

export default withRouter(TopPageViewTable);
